import React from 'react'

const SvgIcon = ({
  children,
  className = '',
  viewBox = '0 0 24 24',
  fontSize = 'medium',
  color = 'inherit',
  sx = {},
  ...props
}) => {
  const getFontSize = () => {
    switch (fontSize) {
      case 'small':
        return '20px'
      case 'medium':
        return '24px'
      case 'large':
        return '35px'
      default:
        return fontSize
    }
  }

  const iconStyles = {
    display: 'inline-block',
    width: getFontSize(),
    height: getFontSize(),
    color: color,
    fill: 'currentColor',
    ...sx
  }

  return (
    <svg className={className} viewBox={viewBox} style={iconStyles} {...props}>
      {children}
    </svg>
  )
}

export default SvgIcon
